module.exports = __webpack_public_path__ + "img/bbc.1f5c8827.png";